import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="terms-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">Terms of Service</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="prose-invert space-y-6 text-zinc-300 text-sm leading-relaxed">
          <p className="text-zinc-500 text-xs">Last updated: February 2026</p>

          <Section title="1. Agreement">
            By purchasing or using Bitcoin Brain ("the Platform"), you agree to these Terms of Service. Bitcoin Brain is operated by Bryce Fields, an individual based in California, USA. If you do not agree to these terms, do not use the Platform.
          </Section>

          <Section title="2. Purchase Terms">
            All purchases on Bitcoin Brain are <strong className="text-white">one-time payments</strong>. There are no subscriptions, recurring charges, or hidden fees. You pay once and own access to your purchased tier forever.
          </Section>

          <Section title="3. No Refunds">
            <strong className="text-white">All sales are final. No refunds will be issued.</strong> Because you receive instant, full access to digital content upon purchase, refunds are not available. Please review the pricing page carefully before purchasing.
          </Section>

          <Section title="4. Account Rules">
            You are responsible for maintaining the security of your account credentials. One account per person. Account sharing is not permitted except through the Educator License, which allows linking up to 4 student accounts.
          </Section>

          <Section title="5. Educator License">
            The Educator License ($99) grants you access to the full Bitcoin Brain course plus the ability to link up to 4 student or family member accounts. Linked accounts receive Standard tier access. The Educator License is not transferable between educators.
          </Section>

          <Section title="6. Fund a Family Program">
            The Fund a Family program is a voluntary community initiative. Contributions ($21 per donation) are processed as part of your purchase and are non-refundable. Funded access is granted at the sole discretion of Bitcoin Brain. Contributions are not tax-deductible. See Fund a Family Terms for full details.
          </Section>

          <Section title="7. BTC XP and Gamification">
            BTC XP, badges, achievements, streaks, and other gamification elements are part of the educational experience only. <strong className="text-white">BTC XP has no monetary value</strong> and cannot be exchanged, transferred, sold, or redeemed for Bitcoin, cash, or any other currency.
          </Section>

          <Section title="8. Content">
            All content on Bitcoin Brain is for educational and entertainment purposes only. It is not financial advice. See our Financial Disclaimer for full details. Course content, quizzes, articles, and AI assistant responses are provided as-is. Bitcoin Brain makes no guarantees about the accuracy or completeness of any content.
          </Section>

          <Section title="9. Payments">
            Bitcoin Brain accepts payment via credit/debit card (processed by Stripe) and Bitcoin via Lightning Network (processed by Strike). All payment processing is handled by these third-party providers under their respective terms. Bitcoin Brain does not store your payment card details.
          </Section>

          <Section title="10. Intellectual Property">
            All content, design, code, and branding on Bitcoin Brain is owned by Bryce Fields. You may not reproduce, redistribute, or resell any content from the Platform without written permission.
          </Section>

          <Section title="11. Limitation of Liability">
            Bitcoin Brain is provided "as is" without warranties of any kind. Bryce Fields is not liable for any damages arising from your use of the Platform, including but not limited to financial decisions made based on educational content.
          </Section>

          <Section title="12. Changes">
            These terms may be updated at any time. Continued use of the Platform after changes constitutes acceptance. Material changes will be communicated via email to registered users.
          </Section>

          <Section title="13. Contact">
            Questions about these terms? Email <a href="mailto:bitcoinbrain21m@gmail.com" className="text-[#F7931A] hover:underline">bitcoinbrain21m@gmail.com</a>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-white font-heading font-bold text-base mb-2">{title}</h2>
      <p>{children}</p>
    </div>
  );
}
